import { render, staticRenderFns } from "./TabLoadConfirm.vue?vue&type=template&id=0a229806"
import script from "./TabLoadConfirm.vue?vue&type=script&lang=js"
export * from "./TabLoadConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports